module.exports = __webpack_public_path__ + "img/ico-question-mark.69c85914.svg";